import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { Spinner } from "pro-features/components/Loaders/src/Spinner";

export const StyledPendingFilterTitleSpinner = styled(Spinner)`
    width: 16px;
    height: 16px;
    border: 2px solid ${colorsPalettes.carbon[100]};
    border-right-color: ${colorsPalettes.blue[400]};
`;

export const StyledPendingFilterBody = styled(Stack)`
    min-height: 120px;
`;

// DotsLoader has no background of its own: its three dots are box-shadows painted at -11/-22/-33px, so
// all its ink sits outside its 6px box, to the left. Size the wrapper to the ink and push the element
// past its right edge so the dots land inside it and centre correctly.
export const StyledPendingFilterDots = styled(Flex)`
    position: relative;
    width: 28px;
    height: 6px;

    > * {
        position: absolute;
        left: 33px;
    }
`;
